// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1gbBA","boxTitle":"Qualiphy_boxTitle__21gg0","box":"Qualiphy_box__2qEUi","toggleWrap":"Qualiphy_toggleWrap__1m6iF"};